import React from "react";
import { Link } from "react-router-dom";
// import MobileSearch from "../mobile-search/MobileSearch";
// import Search from "../sidebar/Search";
import HamMenu from "./HamMenu";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
// import Search from "../sidebar/Search";

import "./MobileNavBar.scss";

const MobileNavBar = () => {
  return (
    <div className="mobile-navbar-container">
      <div className="mobile-navbar-container__mobile-navbar">
        <div className="mobile-navbar-container__ham-menu">
          <HamMenu pageWrapId={"page-wrap"} outerContainerId={"MobileNavBar"} />
        </div>
        <div className="mobile-navbar-container__mob-logo">
          <Link to="/">
            <img
              src={require("../mobile-header/mob-logo.png")}
              alt="mob-logo"
            />
          </Link>
        </div>
        <div className="mobile-navbar-container__mob-search">
          <AccountCircleIcon />
        </div>
      </div>
    </div>
  );
};

export default MobileNavBar;
